<template>
    <div>
        <p>
            Colonne des uid utilisateurs
            <b-input :list="'sn_uid' + id" v-model="column_client_user_uid" size="sm" />
            <datalist :id="'sn_uid' + id">
                <option v-for="(c, ci) in columns_data" :key="'snuid' + ci">{{ c }}</option>
            </datalist>
        </p>
        <p>
            Colonne des identifiants utilisateurs
            <b-input :list="'sn_ident' + id" v-model="column_identifiant" size="sm" />
            <datalist :id="'sn_ident' + id">
                <option v-for="(c, ci) in columns_data" :key="'snid' + ci">{{ c }}</option>
            </datalist>
        </p>
        <p>
            Type de notifications (colonne ou valeur) : notifications ou message
            <b-input :list="'sn_type' + id" v-model="column_type" size="sm" />
            <datalist :id="'sn_type' + id">
                <option v-for="(c, ci) in columns_data" :key="'sntype' + ci">{{ c }}</option>
            </datalist>
        </p>
        <p>
            Colonne ou valeur du titre pour les messages
            <b-input :list="'sn_title' + id" v-model="column_title" size="sm" />
            <datalist :id="'sn_title' + id">
                <option v-for="(c, ci) in columns_data" :key="'sntitle' + ci">{{ c }}</option>
            </datalist>
        </p>
        <p>
            Colonne ou valeur du texte
            <b-input :list="'sn_msg' + id" v-model="column_message" size="sm" />
            <datalist :id="'sn_msg' + id">
                <option v-for="(c, ci) in columns_data" :key="'snmsg' + ci">{{ c }}</option>
            </datalist>
        </p>
        <p>
            Colonne de résultats
            <b-input v-model="column_result" size="sm" />
        </p>
        <p>
            Colonne des erreurs
            <b-input v-model="column_error" size="sm" />
        </p>
        <p>
            <b-checkbox v-model="unique">Unique - envoyer une notification à l'utilisateur du traitement</b-checkbox>
        </p>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    export default {
        name: "send_notifications_step",
        props: {
            data: { default: () => [] },
            files: { default: () => [] },
            client: { default: null },
            size: { default: 1000 },
            step_position: { default: 0 }
        },
        watch: {
            data: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.data.length > 0) {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            }
        },
        data() {
            return {
                id: uniqueId(""),
                columns_data: [],

                column_client_user_uid: "",
                column_identifiant: "",
                column_type: "",
                column_title: "",
                column_message: "",
                column_result: "",
                column_error: "",
                unique: false
            };
        },
        methods: {
            save() {
                return {
                    column_client_user_uid: this.column_client_user_uid,
                    column_identifiant: this.column_identifiant,
                    column_type: this.column_type,
                    column_title: this.column_title,
                    column_message: this.column_message,
                    column_result: this.column_result,
                    column_error: this.column_error,
                    unique: this.unique
                };
            },
            async load(data) {
                if (!data) data = {};
                this.column_client_user_uid = data.column_client_user_uid || "";
                this.column_identifiant = data.column_identifiant || "";
                this.column_type = data.column_type || "";
                this.column_title = data.column_title || "";
                this.column_message = data.column_message || "";
                this.column_result = data.column_result || "";
                this.column_error = data.column_error || "";
                this.unique = !!data.unique;
            }
        }
    };
</script>

<style scoped>
</style>
